/**
 * The iframe URL for the native PDF viewer: the blob plus the PDF Open
 * Parameters fragment. `page` goes first — some viewers read only the leading
 * parameter of the fragment. Kept out of the component file so it can be
 * exported: react-refresh allows only components there.
 */
export function pdfFrameSrc(blobUrl: string, filename?: string, initialPage?: number): string {
  const params: string[] = [];
  if (initialPage != null && Number.isInteger(initialPage) && initialPage > 0) {
    params.push(`page=${initialPage}`);
  }
  if (filename) params.push(`filename=${encodeURIComponent(filename)}`);
  return params.length > 0 ? `${blobUrl}#${params.join("&")}` : blobUrl;
}
